import { FormItemController } from "./FormItemController";
import { Text } from "../../HTML/Form/Item/Text";
import { toMap } from "../../../../HA";

export class TextController extends FormItemController {

    public isInputItem() {
        return true;
    }

    protected createItem() {
        return new Text(toMap({tag: this.getTag(), textarea : this.get("textarea")}));
    }
}
